import React from 'react';
import {Box} from '@mui/material';
import type {StagedFile} from '@securspace/securspace-ui-kit';
import type {ImagePreviewAction} from './ImagePreviewModal';
import {getActionStageSx} from './previewModalStyles';

export interface ActionStageProps {
  file: StagedFile;
  action: ImagePreviewAction;
  onComplete: (updated: StagedFile) => void;
  onCancel: () => void;
  onError?: (message: string) => void;
  fullScreen: boolean;
}

/**
 * Wraps the currently active `ImagePreviewAction`'s panel for
 * `ImagePreviewModal`, owning only the fullScreen-aware container styling
 * (padding/overflow) — the panel itself owns its own layout/behavior.
 */
const ActionStage = ({file, action, onComplete, onCancel, onError, fullScreen}: ActionStageProps) => (
  <Box sx={getActionStageSx(fullScreen)}>
    {action.panel(file, onComplete, onCancel, onError, fullScreen)}
  </Box>
);

export default ActionStage;

